import { PriorityTaskQueue } from 'owa-service/lib/PriorityTaskQueue';

/**
 * Initialize the get persona photo task queue.
 * The queue will control how many getPersonaPhoto requests to make at any given point
 */
const getPersonaPhotoQueue = new PriorityTaskQueue<void>({ maxParallelTasks: 1, taskQuanta: 500 });

export default getPersonaPhotoQueue;
